var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"video",staticClass:"video",attrs:{"poster":require(("assets/img/" + (_vm.content.thumb))),"controls":"","playsinline":"true","preload":"auto"}},[_c('source',{attrs:{"src":require(("assets/videos/" + (_vm.content.src))),"type":"video/mp4"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc4f90d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoComponent.vue
// module id = null
// module chunks = 